import './RightElements.css';
import conti from '../images/conti.gif';

const GetProCard = () => (
  <div className="rightmenu-card get-pro-card">
    <div className="get-pro">
      <img src={conti} alt="ContaLearn mascot" className="get-pro-mascot" />
      <div className="get-pro-title">Invata fara limite</div>
      <div className="get-pro-desc">
       Tot continutul este acum gratuit pe ContaLearn!
      </div>
      <div className="go-premium"><span>Invata gratuit</span></div>
    </div>
  </div>
);

export default GetProCard;
